import React from 'react';
import { toast } from 'react-toastify';

const logError = ({ getState }) => async ({ config, response }, disableToast = false) => {
    let message;
    const {
        data: { error_code = '', error_message = '' },
    } = response.data instanceof Blob ? {data: JSON.parse(await response.data.text())} : response || { data: { error_code: '', error_message: '' } };

    if (error_code === 'IMPORT_ERROR') {
        message = <div style={{ whiteSpace: 'pre' }}>{error_message}</div>;
    } else {
        message = getState().i18n.messages[`toast.error.${error_code}`]
            || getState().i18n.messages['toast.error.defaultMessage']
            || "Quelque chose ne s'est pas passé comme prévu, merci de réessayer";
    }

    if (!disableToast && !error_message.includes('Image with id')) {
        toast.error(message);
    }

    return {
        log_level: 'error',
        timestamp: new Date(),
        context: {
            userAgent: navigator.userAgent,
            location: window.location,
        },
        error: {
            config,
            response,
        },
    };
};

export { logError };
